"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-width: 15rem;\n\t", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var FormContent = _styledComponents.default.div(_templateObject(), function (props) {
  return props.fullWidth ? 'flex-grow: 1' : 'max-width: 20rem; width: 100%;';
});

FormContent.displayName = 'FormContent';
FormContent.defaultProps = {
  fullWidth: false
};
FormContent.propTypes = {
  fullWidth: _propTypes.bool
};
/** @component */

var _default = FormContent;
exports.default = _default;